/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TradeExportDto
 */
export interface TradeExportDto {
    /**
     * 
     * @type {string}
     * @memberof TradeExportDto
     */
    type: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof TradeExportDto
     */
    data: Array<number>;
}

export function TradeExportDtoFromJSON(json: any): TradeExportDto {
    return TradeExportDtoFromJSONTyped(json, false);
}

export function TradeExportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeExportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'data': json['data'],
    };
}

export function TradeExportDtoToJSON(value?: TradeExportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'data': value.data,
    };
}

